module.exports = {"title":"Förening","saveas":"Högerklicka på bilden och \"Spara bilden som\" för att återanvända den"};